import {FC, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useContextProfile} from "context";
import routes from "routes";
import {Loading} from "../shared/Loading/Loading";

export const Redirects: FC = () => {
  const {userData, isLoading} = useContextProfile();
  const navigate = useNavigate();
  const {pathname} = useLocation();

  useEffect(() => { 
    if (
      !isLoading && 
      userData === null && 
      pathname !== routes.landing && 
      !pathname.includes('auth') && 
      !pathname.includes('/'+routes.privactPolicy) &&
      !pathname.includes('/'+routes.termsOfUse)
    ) {
      navigate('/auth/'+routes.auth.login);
    }

    if (
        userData && 
        (
          pathname.includes(routes.auth.login) ||
          pathname.includes(routes.auth.signup)
        )
      ) {
        if (!userData.is_onboarded) {
          navigate('/'+routes.onboarding);
        }
    }

    if (userData && pathname === routes.landing) {
      navigate('/'+routes.activity.main);
    }

  }, [userData, pathname]); // eslint-disable-line

  if (userData !== undefined) return null;

  return <Loading size={"lg"} style={{zIndex: 99999}} />;
};
